module.exports = __webpack_public_path__ + "static/media/good_evening.af9c40bb.png";